"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationAccessEnum = exports.MetaTypeEnum = exports.ReferableTypeEnum = exports.FolderSortColumnEnum = exports.GroupsSortByFieldsEnum = void 0;
var GroupsSortByFieldsEnum;
(function (GroupsSortByFieldsEnum) {
    GroupsSortByFieldsEnum["NAME"] = "name";
    GroupsSortByFieldsEnum["PARENT_NAME"] = "parentName";
    GroupsSortByFieldsEnum["CONTENT_COUNT"] = "contentCount";
    GroupsSortByFieldsEnum["WAIVERS_COUNT"] = "waiversCount";
    GroupsSortByFieldsEnum["PAID_AMOUNT"] = "paidAmount";
})(GroupsSortByFieldsEnum = exports.GroupsSortByFieldsEnum || (exports.GroupsSortByFieldsEnum = {}));
var FolderSortColumnEnum;
(function (FolderSortColumnEnum) {
    FolderSortColumnEnum["NAME"] = "name";
    FolderSortColumnEnum["CATEGORY"] = "category";
})(FolderSortColumnEnum = exports.FolderSortColumnEnum || (exports.FolderSortColumnEnum = {}));
var ReferableTypeEnum;
(function (ReferableTypeEnum) {
    ReferableTypeEnum[ReferableTypeEnum["PROGRAM_SEASON"] = 10] = "PROGRAM_SEASON";
})(ReferableTypeEnum = exports.ReferableTypeEnum || (exports.ReferableTypeEnum = {}));
// The Folder module considers MetaType an opaque value.
// It is passed around and enabled in various queries, but otherwise has no affect on the Folder module's behavior.
// Consumers may extend this enum as needed.
var MetaTypeEnum;
(function (MetaTypeEnum) {
    MetaTypeEnum[MetaTypeEnum["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    // Defined and used by Session Participants -- see that module for more details
    MetaTypeEnum[MetaTypeEnum["GROUP"] = 1] = "GROUP";
    MetaTypeEnum[MetaTypeEnum["TEAM"] = 2] = "TEAM";
})(MetaTypeEnum = exports.MetaTypeEnum || (exports.MetaTypeEnum = {}));
var RegistrationAccessEnum;
(function (RegistrationAccessEnum) {
    RegistrationAccessEnum[RegistrationAccessEnum["OPEN"] = 1] = "OPEN";
    RegistrationAccessEnum[RegistrationAccessEnum["INVITE_LINK_ONLY"] = 2] = "INVITE_LINK_ONLY";
})(RegistrationAccessEnum = exports.RegistrationAccessEnum || (exports.RegistrationAccessEnum = {}));
//# sourceMappingURL=folders.enums.js.map